var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavIconBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "appbar-icon-back",
    transform: "translate(-7 -44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    className: "cls-1",
    width: 44,
    height: 44,
    transform: "translate(7 44)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_19",
    "data-name": "\\uADF8\\uB8F9 19",
    transform: "translate(25 58)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_23",
    "data-name": "\\uD328\\uC2A4 23",
    className: "cls-2",
    d: "M1,9,9,1",
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_44",
    "data-name": "\\uD328\\uC2A4 44",
    className: "cls-2",
    d: "M1,1,9,9",
    transform: "translate(-0.999 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconBack);
export default __webpack_public_path__ + "static/media/nav_icon_back.c96c7f44124eefe407f656c2103ed7ae.svg";
export { ForwardRef as ReactComponent };